import {
  AboutUsPage,
  ContactUsUrl,
  FuelPumpCatalogPage,
  FuelPumpInfoPage,
  HomeUrl,
  WhereToBuyUrl
} from '../../constants/url';

export const navList = [
  {
    name: 'Home',
    url: HomeUrl
  },
  {
    name: 'About Us',
    url: AboutUsPage.Home
  },
  {
    name: 'Fuel Pump Catalog',
    url: FuelPumpCatalogPage.Home
  },
  {
    name: 'Fuel Pump Info',
    url: FuelPumpInfoPage.Home
  },
  {
    name: 'Contact Us',
    url: ContactUsUrl
  },
  {
    name: 'Downloads',
    url: FuelPumpInfoPage.Downloads,
    isOther: true
  },
  {
    name: 'Where to buy',
    url: WhereToBuyUrl,
    isOther: true
  }
];

export const NavActiveFindList = [
  [HomeUrl],
  Object.keys(AboutUsPage).map(key => AboutUsPage[key]),
  Object.keys(FuelPumpCatalogPage).map(key => FuelPumpCatalogPage[key]),
  Object.keys(FuelPumpInfoPage).map(key => FuelPumpInfoPage[key]),
  [ContactUsUrl],
  [],
  [WhereToBuyUrl]
];
